import { render, staticRenderFns } from "./shoppingManage.vue?vue&type=template&id=0626ee56&scoped=true&"
import script from "./shoppingManage.vue?vue&type=script&lang=js&"
export * from "./shoppingManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626ee56",
  null
  
)

export default component.exports